import { Pipe, PipeTransform, SecurityContext } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

const escapeHtml: (s: string) => string = (s: string): string => s
	.replace(/&/g, '&amp;')
	.replace(/</g, '&lt;')
	.replace(/>/g, '&gt;')
	.replace(/"/g, '&quot;')
	.replace(/'/g, '&#039;');

const escapeRegex: (s: string) => string = (s: string): string => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

const highlightHtml: (html: string, query: string) => string = (html: string, query: string): string => {
	if (!query) return html;
	return html.replace(new RegExp(`(${escapeRegex(query)})(?![^<]*>)`, 'gi'), '<span class="search-highlight">$1</span>');
};

@Pipe({ name: 'searchHighlight', standalone: true })
export class SearchHighlightPipe implements PipeTransform {
	constructor(private sanitizer: DomSanitizer) {
	}

	transform(value: string | SafeHtml, query: string): SafeHtml {
		if (!value) return '';

		let html: string;
		if (typeof value === 'string') {
			html = escapeHtml(value);
		} else {
			html = this.sanitizer.sanitize(SecurityContext.HTML, value) ?? '';
		}

		return this.sanitizer.bypassSecurityTrustHtml(
			highlightHtml(html, (query ?? '').trim())
		);
	}
}
